// extracted by mini-css-extract-plugin
export default {"cls1":"FreeformQuestion-cls1_XeC","cls2":"FreeformQuestion-cls2_yIE FreeformQuestion-cls1_XeC","labeled":"FreeformQuestion-labeled_PnC"};